import type { HighlightableConstituent, PartProps } from '../Part';

export type GetHighlightQueryStringForConstituentParams = {
  constituent: HighlightableConstituent;
  highlight: PartProps['highlight'];
};

export const getHighlightQueryStringForConstituent = ({
  constituent,
  highlight,
}: GetHighlightQueryStringForConstituentParams): string | null => {
  if (highlight) {
    return typeof highlight === 'string'
      ? highlight
      : highlight[constituent] || null;
  }

  return null;
};
